import { render, staticRenderFns } from "./DailyPuzzle.vue?vue&type=template&id=1451a621&scoped=true&"
import script from "./DailyPuzzle.vue?vue&type=script&lang=js&"
export * from "./DailyPuzzle.vue?vue&type=script&lang=js&"
import style0 from "./DailyPuzzle.vue?vue&type=style&index=0&id=1451a621&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451a621",
  null
  
)

export default component.exports